import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the service worker for PWA + offline capability.
// When a NEW SW takes over (controllerchange), reload exactly once so the user
// instantly gets fresh HTML/JS/CSS — fixes the "stuck on old version after
// deploy" problem without manual hard-reloads.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      // If a waiting worker is already there, force activation right away.
      if (reg.waiting) reg.waiting.postMessage({ type: "SKIP_WAITING" });
      // Re-check for a new SW on every app resume — PWAs/Android browsers
      // resume from memory without a navigation, so without this a phone
      // could run a stale build for days after a redeploy.
      const forceUpdate = () => { try { reg.update(); } catch { /* ignore */ } };
      forceUpdate();
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") forceUpdate();
      });
      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            sw.postMessage({ type: "SKIP_WAITING" });
          }
        });
      });
    }).catch((err) => {
      // eslint-disable-next-line no-console
      console.warn("SW registration failed:", err);
    });
  });
}
